var map = {
	"./Catarina_Nunes.jpg": 707,
	"./Diogo_Morais.jpg": 8354,
	"./Marta_Martins.jpg": 70045,
	"./Miriam_Ferreira.jpg": 88174,
	"./Nádia_Gaspar.jpg": 17548
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92010;